import React, { useState } from "react";
import { TaskList } from "../components/TaskList";
import { Navbar } from "../components/Navbar";
import { Sidebar } from "../components/home/Sidebar";
import { TaskForm } from "../components/TaskForm";
import { ProjectForm } from "../components/home/ProjectForm";
import { useProjects } from "../context/ProjectContext";
import { useAuth } from "../context/AuthContext";

export const Home = () => {
    const { user } = useAuth();
    const [taskFilter, setTaskFilter] = useState('inbox');
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [isAddTaskOpen, setIsAddTaskOpen] = useState(false);
    const [isAddProjectOpen, setIsAddProjectOpen] = useState(false);

    // Para el buscador de tareas
    const [searchQuery, setSearchQuery] = useState("");

    const { projects } = useProjects(); // 2. Consumimos los proyectos globales

    // 3. Función helper para resolver el título correcto de forma dinámica
    const getPageTitle = () => {
        if (taskFilter === 'inbox') return 'Bandeja de Entrada';
        if (taskFilter === 'today') return 'Hoy';
        if (taskFilter === 'upcoming') return 'Próximo';

        if (taskFilter.startsWith('project-')) {
            const projectId = Number(taskFilter.split('-')[1]);
            // Buscamos el proyecto en la base de datos local del context
            const activeProject = projects.find(proj => proj.id === projectId);
            return activeProject ? `${activeProject.icon} ${activeProject.name}` : 'Proyecto';
        }

        return 'Tareas';
    };

    return (
        <div className="min-h-screen bg-white flex flex-col">
            {/* Navbar con control de búsqueda */}
            <Navbar
                user={user}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
            />

            {/* Contenedor Flex para Sidebar + Contenido */}
            <div className="flex flex-1 min-h-[calc(100vh-4rem)]">

                {/* Sidebar izquierdo */}
                <Sidebar
                    user={user}
                    currentFilter={taskFilter}
                    setFilter={setTaskFilter}
                    isOpen={isSidebarOpen}
                    setIsOpen={setIsSidebarOpen}
                    onAddTaskClick={() => setIsAddTaskOpen(true)}
                    onAddProjectClick={() => setIsAddProjectOpen(true)}
                />

                {/* Área de Contenido Principal centralizada */}
                <main className="flex-1 ml-14 lg:ml-0 p-4 md:p-8 bg-white overflow-y-auto h-[calc(100vh-4rem)]">
                    <div className="max-w-3xl mx-auto">
                        <h2 className="text-xl font-bold text-gray-800 mb-6">
                            {searchQuery ? `Resultados de la búsqueda: "${searchQuery}"` : getPageTitle()}
                        </h2>

                        {/* Le enviamos searchQuery al TaskList */}
                        <TaskList filter={taskFilter} searchQuery={searchQuery} />
                    </div>
                </main>

                {/* Modal para agregar tareas */}
                <TaskForm
                    isOpen={isAddTaskOpen}
                    onClose={() => setIsAddTaskOpen(false)}
                />

                {/* Modal para agregar proyectos */}
                <ProjectForm
                    isOpen={isAddProjectOpen}
                    onClose={() => setIsAddProjectOpen(false)}
                />
            </div>
        </div>
    );
};